//@flow
import { data } from "cockpit-shared";
import * as constants from "../constants";

export function getLocalizedDateFormatter(): data.date.MomentDateFormattingService {
  let localeId = constants.Device.Locale;
  return new data.date.MomentDateFormattingService(localeId);
}
